import { CardLoader } from '@betterment/shared-components/src/components/card-loader/card-loader';

import { UserBalancePerformanceQuery } from './graphql/userPerformanceBalance.generated';

export type BalanceChartProps = {
  history: UserBalancePerformanceQuery['performance']['history'] | undefined;
};

export const BalanceChart: React.FC<BalanceChartProps> = ({ history }) => {
  if (!history) {
    return <CardLoader />;
  }

  return <div>Placeholder: Balance chart with {history.timeSeries.length} data points</div>;
};
